import { type WrappedInsightSummaryAttributes } from "@clipboard-health/contract-backend-main";
import { Span, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { PageFooterWrapper } from "@src/appV2/redesign/components/PageFooterWrapper";

import bunnyIcon from "../../assets/bunny-wrapped.png";

interface SummaryContentProps {
  attributes: WrappedInsightSummaryAttributes;
  onFinish?: () => void;
  isPreview?: boolean;
}

function formatNumber(value: number): string {
  return new Intl.NumberFormat("en-US").format(value);
}

export function SummaryContent(props: SummaryContentProps) {
  const { attributes, onFinish, isPreview = false } = props;

  return (
    <Stack sx={{ flex: 1, minHeight: 0, paddingTop: 8, overflow: "hidden" }}>
      <Stack
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          paddingX: 8,
          paddingTop: 8,
          paddingBottom: 2,
        }}
        spacing={3}
      >
        {/* Text section */}
        <Stack spacing={4}>
          <Stack spacing={1}>
            <Text variant="body1" color="white">
              In 2025, you were one of
            </Text>
            <Text variant="body1" color="white">
              <Span sx={{ fontSize: "2rem" }}>
                {formatNumber(attributes.numberOfProfessionals)}
              </Span>{" "}
              professionals on Clipboard.
            </Text>
          </Stack>

          <Box>
            <Text variant="body1" color="white">
              You worked
            </Text>
            <Text variant="h1" sx={{ fontSize: "2.5rem", fontWeight: 500, color: "white" }}>
              {formatNumber(attributes.shiftsWorked)}
            </Text>
            <Text variant="body1" color="white">
              shifts as a
            </Text>
            <Text variant="h2" sx={{ fontWeight: 500, color: "white" }}>
              {attributes.mainQualification}
            </Text>
          </Box>

          <Text variant="body1" color="white">
            There&apos;s no way to measure the care you provided, but we see you. Thank you.
          </Text>
        </Stack>

        {/* Bunny image - fills remaining space */}
        <Stack sx={{ flex: 1, minHeight: 0 }} alignItems="center" justifyContent="center">
          <Box
            component="img"
            src={bunnyIcon}
            alt="Bunny"
            sx={{
              width: "100%",
              height: "100%",
              maxWidth: 280,
              maxHeight: 280,
              objectFit: "contain",
            }}
          />
        </Stack>
      </Stack>
      {!isPreview && (
        <PageFooterWrapper>
          <Button fullWidth variant="contained" size="large" onClick={onFinish}>
            Finish
          </Button>
        </PageFooterWrapper>
      )}
    </Stack>
  );
}
